export default class MerchantSetting {
  public readonly isCourseDurationVisible: boolean;
  public readonly isCustomerReviewActive: boolean;
  public readonly isNoindex: boolean;
  public readonly isPastTimeSlotsVisible: boolean;
  public readonly isExploreOnly: boolean;
  public readonly exploreOnlyMerchantReservationPageUrl: string;
  public readonly contactUrl: string | null;

  constructor(init: MerchantSettingInit) {
    this.isCourseDurationVisible = init.isCourseDurationVisible;
    this.isCustomerReviewActive = init.isCustomerReviewActive;
    this.isNoindex = init.isNoindex;
    this.isPastTimeSlotsVisible = init.isPastTimeSlotsVisible;
    this.isExploreOnly = init.isExploreOnly;
    this.exploreOnlyMerchantReservationPageUrl =
      init.exploreOnlyMerchantReservationPageUrl;
    this.contactUrl = init.contactUrl;
  }
}

export interface MerchantSettingInit {
  isCourseDurationVisible: boolean;
  isCustomerReviewActive: boolean;
  isNoindex: boolean;
  isPastTimeSlotsVisible: boolean;
  isExploreOnly: boolean;
  exploreOnlyMerchantReservationPageUrl: string;
  contactUrl: string | null;
}
